<template>
    <l-map
        :style="'height: ' + height "
        :center="[posicao.lat, posicao.long]"
        ref="mapComponent"
    >
        <l-marker v-bind:key="posicao.id_rastreador" :lat-lng="[posicao.lat, posicao.long]" ></l-marker>
        <l-tile-layer :url="url" layer-type="base"></l-tile-layer>
    </l-map>
</template>

<script>
    import {LMap, LTileLayer, LMarker} from 'vue2-leaflet';

    export default {
        name: 'MapComponent',

        components: {
            LMap,
            LTileLayer,
            LMarker
        },

        props: {
            posicao: {
                default: null
            },
            height: {
                default: '200px'
            }
        },

        data () {
            return {
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                zoom: 16,
                center: [47.413220, -1.219482],
                bounds: null
            };
        },

        mounted() {
            setTimeout(() => this.centerAll(), 100);
        },

        methods: {
            centerAll () {
                this.$refs.mapComponent.mapObject.invalidateSize();
                this.$refs.mapComponent.mapObject.fitBounds([[this.posicao.lat, this.posicao.long]], {padding: [60, 60]});
                //this.$refs.mapComponent.mapObject.setView([this.posicao.lat, this.posicao.long]);
                this.$forceUpdate();
            }
        }
    };
</script>

<style scoped>

</style>
